import React, { Component } from "react";
import styles from "./css/JoinProServicePage.module.css";

import { Link } from "react-router-dom";

import Navbar from "../CommonComponents/Navbar";
import Footer from "../CommonComponents/Footer";
export class JoinProServicePage extends Component {
  render() {
    return (
      <div className={styles.joinProServicePage}>
        <div className={styles.joinProServicePageInner}>
          <Navbar></Navbar>
            
          <div className={styles.bodyBlock}>
            <div className={styles.block1}>
              <div className={styles.block1Inner}>
                <div className={styles.block1Left}>
                  <div className={styles.block1LeftInner}>
                    <h2 className={styles.heading}>Our Pro Service</h2>
                    <div className={styles.description}>
                      <p>
                        Increase your exposure to millions of homeowners looking
                        to find local contractors just like you. We make it easy
                        to build and send job quotes to potential customers.
                      </p>
                    </div>
                    <div className={styles.joinUsBtnCont}>
                      <Link to="/join-us">Join Us</Link>
                    </div>
                  </div>
                </div>
                <div className={styles.block1Right}>
                  <img src="/assets/img/proService1.svg" />
                </div>
              </div>
            </div>
            <div className={styles.block2}>
              <div className={styles.block2Inner}>
                <div className={styles.block2Left}>
                  <img src="/assets/img/proService2.svg" />
                </div>
                <div className={styles.block2Right}>
                  <div className={styles.block2RightInner}>
                    <h2 className={styles.heading}>Property Management</h2>
                    <div className={styles.description}>
                      <p>
                        Increase your exposure to millions of homeowners looking
                        to find local contractors just like you. We make it easy
                        to build and send job quotes to potential customers.
                      </p>
                    </div>
                    <div className={styles.joinUsBtnCont}>
                      <Link to="/join-us">Join Us</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer></Footer>
        </div>
      </div>
    );
  }
}

export default JoinProServicePage;
